import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./storeWatchers/index";
import "./quasar";
import "./amplify-i18n";
import i18n from "./locale";
import "./amplify-configure";
import "./filters";
import * as VueGoogleMaps from "vue2-google-maps";

// import "./styles/tailwind.css";
import "windi.css";

import * as Sentry from "@sentry/vue";
// import { Integrations } from "@sentry/tracing";

Sentry.init({
  Vue,
  // dsn: "https://ed0691d722c34f648e3f3b093f3c5765@o1071900.ingest.sentry.io/6125276",
  dsn: "https://238a2dc6737d4387bae660993f509987@o4504960688717824.ingest.sentry.io/4504960690159616",
  replaysSessionSampleRate: 0.1,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    new Sentry.Replay(),
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ["localhost", "portal.villamarket.net", /^\//],
    }),
  ],
  // integrations: [
  //   new Integrations.BrowserTracing({
  //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
  //     tracingOrigins: ["localhost", "portal.villamarket.net", /^\//],
  //   }),
  // ],
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "Avoided redundant navigation",
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

import VueApexCharts from "vue-apexcharts";

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

import { prepareServices } from "./ui/plugins/services";
prepareServices(store);

Vue.config.productionTip = false;
new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// store.$services.apikey.getApikey().then(response => {
//   console.log('apikey map', response)

//   const { googlemapApikey } = response;
//   Vue.use(VueGoogleMaps, {
//     load: {
//       key: "AIzaSyDLZah0ZlCiCazImCg5jbhywjkqHlEio4c",
//       libraries: "places", // This is required if you use the Autocomplete plugin
//       // OR: libraries: 'places,drawing'
//       // OR: libraries: 'places,drawing,visualization'
//       // (as you require)

//       //// If you want to set the version, you can do so:
//       // v: '3.26',
//     },
//   });
//   console.log('google map initiated')
// });

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDLZah0ZlCiCazImCg5jbhywjkqHlEio4c",
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});
console.log('google map initiated')

console.log(".");